<h2 class="text-center mb-4">Email confirmation</h2>
<form *ngIf="!confirmemail; else emailSent" #loginForm="ngForm" name="loginForm" class="m-0" (ngSubmit)="OnSubmit(email.value)" autocomplete="off">
  <div class="fieldset">
    <label for="email" class="legend">Email</label>
    <input type="email" name="email" id="email" class="text-field" [disabled]="isLoading" ngModel #email required>
  </div>
  <button *ngIf="!isLoading; else sendingEmail" type="submit" class="btn" [disabled]="this.loginForm.invalid">Resend verification email</button>
  <ng-template #sendingEmail>
    <button class="btn btn--loading" type="button">Sending email...</button>
  </ng-template>
</form>
<ng-template #emailSent>
  <p class="alert alert-success font-weight-bold text-center"><i class="mdi mdi-error"></i>Email sent. Please, verify your account by clicking the verification link sent to your email</p>
  <p class="text-links-wrap"><a routerLink="/access/resendemailverification" class="text-link m-auto">Resend Verification Email</a></p>
</ng-template>
